import Bowser from 'bowser'
import { CREATE_ERROR_REPORT } from '@/graphql/mutations/ErrorReport'
import { debounce, startsWith } from 'lodash-es'
import StackTrace from 'stacktrace-js'
import * as Sentry from '@sentry/browser'

import { client } from '@/components/App/client'

const sendError = debounce(error => {
  StackTrace.fromError(error)
    .then(stackframes => {
      const stringifiedStack = stackframes.map(sf => sf.toString()).join('\n')

      if (startsWith(stringifiedStack, 'dataIdFromObject')) {
        return
      }

      client.mutate({
        mutation: CREATE_ERROR_REPORT,
        variables: {
          error: `${error.message}\n${stringifiedStack}`,
          routeName: window.location.href,
          userAgent: Bowser.parse(window.navigator.userAgent),
        },
      })
    })
    .catch(() => {})
}, 1000)

export const logError = (error: Error) => {
  const unknownError =
    'Error: GraphQL error: An unknown error has occurred!  Please try again later'

  const dynamicImportedModuleError =
    'Failed to fetch dynamically imported module'

  if (
    sessionStorage.getItem('accessToken') &&
    process.env.NODE_ENV === 'production' &&
    !error?.stack?.includes(unknownError) &&
    !error?.stack?.includes(dynamicImportedModuleError) &&
    !error?.message?.includes('Invariant Violation: 8')
  ) {
    Sentry.captureException(error)
    sendError(error)
  }
}
